<template>
  <div class="container">
    <section id="editContent" class="columnContainer categoryList">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_category}}</h1>
        <CategoryList :locale="locale" :edit="true" />
      </div>
      <div class="innerSide"><div class="sideBox">
      </div></div>
    </section>
    <div id="setContent">
      <SetCategory :locale="locale" />
    </div>
  </div>
</template>

<script>
import SetCategory from '@/components/Category/Setting'
import CategoryList from '@/components/Category/List'

export default {
  name: 'Category',
  components: {
    SetCategory,
    CategoryList
  },
  props: [
    'locale'
  ],
  mounted () {
  },
  methods: {
  }
}
</script>
